import '../SectionMainComponents/section-main-components.css';
import Container from '../../@common.blocks/Container';
import Title from '../../@common.blocks/Title/index';
import { HashLink } from 'react-router-hash-link';
import Button from '../../@common.blocks/Button/index';

import WorkLogo_1 from '../../pictures/worklogo1.png';
import WorkLogo_2 from '../../pictures/worklogo2.png';
import WorkLogo_3 from '../../pictures/worklogo3.png';

import WorkLogo_13 from '../../pictures/worklogo13.png';
import WorkLogo_18 from '../../pictures/worklogo18.png';
import WorkLogo_15 from '../../pictures/worklogo15.png';

const SectionMainComponents = () => {
  return (
    <div className="section-main-components">
      <Container>
        <div className="section-main-components__equipment">
          <Title level="2" size="veryBg">
            Оборудование
          </Title>
          <div className="section-main-components__equipment-wrapper">
            <div className="section-main-components__equipment-card">
              <div className="section-main-components__equipment-minicard">
                <div className="section-main-components__equipment-picture">
                  <img src={WorkLogo_1} alt="" />
                </div>
                <div>
                  <div className="section-main-components__equipment-text">
                    <p>
                      Компания TDM ELECTRIC - лидер в комплексном производстве
                      электро- и светотехники, кабельно-проводниковой продукции,
                      тепловой техники, вентиляции, инструмента на территории
                      РФ, стран СНГ и ближнего зарубежья...
                    </p>
                  </div>
                  <HashLink to="/equipping#equipping_TDM">
                    Узнать больше
                  </HashLink>
                </div>
              </div>
            </div>
            <div className="section-main-components__equipment-card">
              <div className="section-main-components__equipment-minicard">
                <div className="section-main-components__equipment-picture">
                  <img src={WorkLogo_2} alt="" />
                </div>
                <div>
                  <div className="section-main-components__equipment-text">
                    <p>
                      Основные товарные направления компании EKF: низковольтная
                      электротехническая продукция, оборудование среднего
                      напряжения, корпуса электрощитов, изделия для
                      электромонтажа и электроустановки, средства измерения,
                      кабеленесущие системы, шинопровод...
                    </p>
                  </div>
                  <HashLink to="/equipping#equipp_EKF">Узнать больше</HashLink>
                </div>
              </div>
            </div>
            <div className="section-main-components__equipment-card">
              <div className="section-main-components__equipment-minicard">
                <div className="section-main-components__equipment-picture">
                  <img src={WorkLogo_3} alt="" />
                </div>
                <div>
                  <div className="section-main-components__equipment-text">
                    <p>
                      АО "ДКС" (DKC) производит продукцию для организации систем
                      электроснабжения, автоматизации и распределения энергии на
                      объектах любого назначения.Сегодня это – один из
                      крупнейших производителей электорооборудования в России и
                      Европе...
                    </p>
                  </div>
                  <HashLink to="/equipping#equipping_DKC">
                    Узнать больше
                  </HashLink>
                </div>
              </div>
            </div>
          </div>
          <Button color="orange">
            <HashLink to="/equipping" id="link">
              Узнать о другом оборудование
            </HashLink>
          </Button>
        </div>
        <div className="section-main-components__controllers">
          <Title level="2" size="veryBg">
            Контроллеры
          </Title>
          <div className="section-main-components__controllers-wrapper">
            <div className="section-main-components__controllers-card">
              <div className="section-main-components__controllers-minicard">
                <div className="section-main-components__controllers-picture">
                  <img src={WorkLogo_13} alt="" />
                </div>
                <div>
                  <div className="section-main-components__controllers-text">
                    <p>
                      Концерн Siemens уже несколько десятилетий занимается
                      производством регулируемых электроприводов. Не осталось,
                      пожалуй, ни одной области жизни, где бы они не
                      применялись. Существенная экономия электроэнергии....
                    </p>
                  </div>
                  <HashLink to="/controllers">Узнать больше</HashLink>
                </div>
              </div>
            </div>
            <div className="section-main-components__controllers-card">
              <div className="section-main-components__controllers-minicard">
                <div className="section-main-components__controllers-picture">
                  <img src={WorkLogo_18} alt="" />
                </div>
                <div>
                  <div className="section-main-components__controllers-text">
                    <p>
                      Ведущий российский разработчик и производитель
                      контрольно-измерительных приборов и средств промышленной
                      автоматизации. ОВЕН работает с 1991 года...
                    </p>
                  </div>
                  <HashLink to="/controllers">Узнать больше</HashLink>
                </div>
              </div>
            </div>
            <div className="section-main-components__controllers-card">
              <div className="section-main-components__controllers-minicard">
                <div className="section-main-components__controllers-picture">
                  <img src={WorkLogo_15} alt="" />
                </div>
                <div>
                  <div className="section-main-components__controllers-text">
                    <p>
                      Unitronics разрабатывает, производит и продвигает
                      передовые решения для управления и автоматизации. Мы
                      предлагаем широкий модельный ряд PLC, PLC со встроенным
                      HMI, полную линейку преобразователей частоты (ПЧ) ....
                    </p>
                  </div>
                  <HashLink to="/controllers">Узнать больше</HashLink>
                </div>
              </div>
            </div>
          </div>
          <Button color="orange">
            <HashLink to="/controllers" id="link">
              Узнать о других контроллерах
            </HashLink>
          </Button>
        </div>
      </Container>
    </div>
  );
};
export default SectionMainComponents;
